import React from "react";
import { Navigate } from "react-router-dom";
import { getCookie, hasValidToken, clearSession } from "../../utils/cookies";

const PrivateRoute = ({ children }) => {
  const token = getCookie("token");

  if (!token) {
    return <Navigate to="/auth/login" replace />;
  }

  if (!hasValidToken()) {
    clearSession();
    return <Navigate to="/auth/login" replace />;
  }

  return children;
};

export default PrivateRoute;
